import { Mail, Phone, MapPin, Instagram, Facebook } from "lucide-react";
import { BRAND, NAV_LINKS } from "../data/brand";

export default function Footer() {
  const goTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer data-testid="footer-section" className="relative border-t border-white/5 bg-black">
      {/* Watermark */}
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-8">
        <div
          aria-hidden
          className="pointer-events-none select-none text-center heading chrome-text text-[12vw] leading-none opacity-20 mb-16 tracking-tighter"
          data-testid="footer-watermark"
        >
          NEXA WASH
        </div>

        <div className="grid md:grid-cols-4 gap-10 mb-16">
        <div className="md:col-span-2">
            <img
              src="/assets/logo-nexawash.png"
              alt="NexaWash Studio logo"
              className="h-16 w-auto mb-4"
              data-testid="footer-logo"
            />
            <p className="text-nexa-muted text-sm leading-relaxed max-w-md">
              Lavaggio auto nanotech waterless a Rieti. Ecologico, professionale, mobile. Wash &amp; Go.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center border border-white/10 hover:border-nexa-blue hover:text-nexa-blue transition-colors"
                data-testid="social-instagram"
                aria-label="Instagram"
              >
                <Instagram size={16} />
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center border border-white/10 hover:border-nexa-blue hover:text-nexa-blue transition-colors"
                data-testid="social-facebook"
                aria-label="Facebook"
              >
                <Facebook size={16} />
              </a>
            </div>
          </div>

          <div>
            <div className="overline mb-4">Sezioni</div>
            <ul className="space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    onClick={() => goTo(l.id)}
                    data-testid={`footer-link-${l.id}`}
                    className="text-sm text-nexa-muted hover:text-nexa-blue transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="overline mb-4">Contatti</div>
            <ul className="space-y-3">
              <li>
                <a href={`mailto:${BRAND.email}`} className="flex items-start gap-3 text-sm text-nexa-muted hover:text-white transition-colors" data-testid="footer-email">
                  <Mail size={14} className="mt-1 text-nexa-blue shrink-0" />
                  <span>{BRAND.email}</span>
                </a>
              </li>
              <li>
                <a href={`tel:${BRAND.phone.replace(/\s/g, "")}`} className="flex items-start gap-3 text-sm text-nexa-muted hover:text-white transition-colors" data-testid="footer-phone">
                  <Phone size={14} className="mt-1 text-nexa-blue shrink-0" />
                  <span>{BRAND.phoneDisplay}</span>
                </a>
              </li>
              <li>
                <a href={BRAND.mapUrl} target="_blank" rel="noreferrer" className="flex items-start gap-3 text-sm text-nexa-muted hover:text-white transition-colors" data-testid="footer-address">
                  <MapPin size={14} className="mt-1 text-nexa-blue shrink-0" />
                  <span>{BRAND.addressLong}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-nexa-muted">
          <div>
            © {new Date().getFullYear()} NexaWash Studio. Tutti i diritti riservati.
          </div>
          <div className="flex items-center gap-6">
            <span>P.IVA {BRAND.piva}</span>
            <span className="tracking-widest uppercase">{BRAND.domain}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
